









 
// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditMns.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine'
import { toStringDictionary } from '@/utils/groupBy';
import { getImageUrl } from '@/utils/images';

@Component({
  name: 'ReadMns',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadMns extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean 

  get getImageUrl(){
    return getImageUrl;
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
